export default "__VITE_ASSET__DvLGM7lR__"